import React, { useReducer } from "react";
import {
  GET_SPECIFIC_NEWS,

  START_NEWS_LOADING,
  STOP_NEWS_LOADING,
  GET_NEWS,
  GET_NEWS_ERROR,
  SET_NEWS_PAGE,
  SET_FILTER_TYPE,
  CLEAR_NEWS,
  GET_TOPICS,
  GET_NEWS_BY_TOPIC,
  START_TOPICS_LOADING,
  STOP_TOPICS_LOADING,
} from "../types";
import NewsContext from "./NewsContext";
import NewsReducer from "./NewsReducer";
import axios from "axios";
import dotenv from "dotenv";
dotenv.config();
const NewsState = ({ children }) => {
  const initialState = {
    newsLoading: true,
    news: null,
    newsError: null,
    newsPage: 1,
    specificNews: null,
    sentimentData: null,
    filterType: "Positive",
    topics: null,
    topicsLoading: false,
    topicNews: null,
  };
  const [state, dispatch] = useReducer(NewsReducer, initialState);
  const getNews = async (page = 1, ctype) => {
    try {
      state.newPage < 2 && dispatch({ type: START_NEWS_LOADING });

      if (ctype === "single" || state.filterType === "All") {
        const { data } = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/news/generalCryptoNews?pageNo=${page}&limit=10`
        );
        dispatch({ type: GET_NEWS, payload: data, ctype });
      } else if (
        state.filterType === "Positive" ||
        state.filterType === "Negative" ||
        state.filterType === "Neutral"
      ) {
        const { data } = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/news/getSentimentNews?sentiment=${state.filterType}&pageNo=${page}&limit=10`
        );
        dispatch({ type: GET_NEWS, payload: data });
      } else if (state.filterType === "Events" && ctype !== "single") {
        const { data } = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/news/eventNews?pageNo=${page}&limit=10`
        );
        dispatch({ type: GET_NEWS, payload: data });
      }
      //place order in vt

      state.newsPage < 2 && dispatch({ type: STOP_NEWS_LOADING });
    } catch (err) {
      dispatch({
        type: GET_NEWS_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
  };
  const setNewsPage = (data) => {
    dispatch({ type: SET_NEWS_PAGE, payload: data });
  };
  const getSpecificNews = async (coin, page = 1) => {
    try {
      dispatch({ type: START_NEWS_LOADING });

      const { data } = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/news/coinSpecificNews?cname=${coin}`
      );
      //place order in vt
      dispatch({ type: GET_SPECIFIC_NEWS, payload: data });
      dispatch({ type: STOP_NEWS_LOADING });
    } catch (err) {
      dispatch({
        type: GET_NEWS_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
  };
  const setFilterType = (type) => {
    dispatch({ type: SET_FILTER_TYPE, payload: type });
  };
  const clearNews = () => {
    dispatch({ type: CLEAR_NEWS });
  };
  const getTopics = async () => {
    try {

      const { data } = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/news/getTopics`
      );
      //place order in vt
      dispatch({ type: GET_TOPICS, payload: data });

    } catch (err) {
      dispatch({
        type: GET_NEWS_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
  };
  const getNewsByTopic = async (page = 1,filterType=state.filterType) => {
    try {
      dispatch({ type: START_TOPICS_LOADING });

      const { data } = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/news/generalCryptoNews?pageNo=${page}&limit=10&topic=${filterType}`
      );
      //place order in vt
      dispatch({ type: GET_NEWS_BY_TOPIC, payload: data });
      dispatch({ type: STOP_TOPICS_LOADING });
    } catch (err) {
      dispatch({
        type: GET_NEWS_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
  };

  return (
    <NewsContext.Provider
      value={{
        news: state.news,
        newsLoading: state.newsLoading,
        getNews,
        setNewsPage,
        newsError: state.newsError,
        newsPage: state.newsPage,
        getSpecificNews,
        specificNews: state.specificNews,
        sentimentData: state.sentimentData,
        filterType: state.filterType,
        setFilterType,
        clearNews,
        getTopics,
        topics: state.topics,
        topicsLoading: state.topicsLoading,
        topicNews: state.topicNews,
        getNewsByTopic,
      }}
    >
      {children}
    </NewsContext.Provider>
  );
};

export default NewsState;
